import { Injectable } from '@angular/core';
import {GeneralServicesImplService} from '../../../services/general-services-impl.service';
import {HttpClient} from '@angular/common/http';
import * as servers from '../../../services/api/servers';
import {urls} from '../../../services/api/urls';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {ProjectConstants} from '../../project-constants';

@Injectable({
  providedIn: 'root'
})
export class LocalCustomerAnagrafService extends GeneralServicesImplService {

  constructor(http: HttpClient) {
    super(http);
  }

  // baseUrl: string = servers.apiUrl + urls.cobidbService + urls.localCustomer;
  baseUrl: string = servers.apiUrl + urls.localCustomer;

  getPage(offset: any, filter?: any): Observable<any> {
    const url = this.baseUrl + this.LINKS.PAGE;
    const body =  filter ? JSON.stringify(filter) : null;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post( url, body, {headers: header, responseType: 'json', params: offset})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }

  getPageInLocalCustomerSettings(offset: any, filter?: any): Observable<any> {
    const url = this.baseUrl + this.LINKS.PAGE_IN_LOCAL_CUSTOMER_SETTING;
    const body =  filter ? JSON.stringify(filter) : null;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post( url, body, {headers: header, responseType: 'json', params: offset})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }


  getPageInAllSettings(offset: any, filter?: any): Observable<any> {
    const url = this.baseUrl + this.LINKS.PAGE_IN_ALL_SETTING;
    const body =  filter ? JSON.stringify(filter) : null;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post( url, body, {headers: header, responseType: 'json', params: offset})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }

  getPageInAllContractMonth(offset?: any, filter?: any): Observable<any> {
    const url = this.baseUrl + this.LINKS.PAGE_IN_ALL_CONTRACT_MONTH;
    const body =  filter ? JSON.stringify(filter) : null;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post( url, body, {headers: header, responseType: 'json', params: offset})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }

  getListInLocalCustomerSetting(filter: any): Observable<any> {
    const url = this.baseUrl + this.LINKS.LIST_IN_LOCAL_CUSTOMER_SETTING;
    const body =  filter;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post( url, body, {headers: header, responseType: 'json'})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }

  getListInContractTypeSetting(filter: any): Observable<any> {
    const url = this.baseUrl + this.LINKS.LIST_IN_CONTRACT_TYPE_SETTING;
    const body =  filter;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post( url, body, {headers: header, responseType: 'json'})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }

  getListInCurrencySetting(filter: any): Observable<any> {
    const url = this.baseUrl + this.LINKS.LIST_IN_CURRENCY_SETTING;
    const body =  filter;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post( url, body, {headers: header, responseType: 'json'})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }

  softDelete(id: number): Observable<any> {
    const url = this.baseUrl  + this.LINKS.SOFT_DELETE + id;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.delete(url, {headers: header, responseType: 'json'})
      .pipe(
        map (data => data)
      );
  }
}
